import { Routes } from '@angular/router';
import { AuthGuard } from './core/services/auth/auth-guard-service.guard';
import { SkipRegisterGuard } from './core/services/auth/skip-register.guard';
import { BilDashboardComponent } from './home/bil-dashboard/bil-dashboard.component';
const ɵ0 = () => import("./registration/registration.module.ngfactory").then(module => module.RegistrationModuleNgFactory), ɵ1 = () => import("./home/home.module.ngfactory").then(module => module.HomeModuleNgFactory);
const routes = [
    {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full'
    },
    {
        path: 'registration',
        loadChildren: ɵ0,
        canLoad: [SkipRegisterGuard]
    },
    {
        path: 'bil',
        loadChildren: ɵ1,
    },
    { path: 'dashboard', component: BilDashboardComponent, canActivate: [AuthGuard] }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1 };
